'use strict';

// Localisations
// ============
module.exports = {
  en: {
    filter: 'Filter Users...',
    title: 'Password Management',
    changepasswords: 'Change Passwords',
    message: 'Global admins can reset passwords and block accounts here.',
    titleleft: 'Full User List',
    messageleft: 'List of ALL users in the foeface system. Click on a user to add or remove from the bulk password change list.',
    titleright: 'Password Change List',
    messageright: 'List of users who will be included in the change password process.  After changing you will be able to download new passwords as a PDF.'
  },
  es: {
    filter: 'Filter Users...',
    title: 'Password Management',
    changepasswords: 'Change Passwords',
    message: 'Global admins can reset passwords and block accounts here.',
    titleleft: 'Full User List',
    messageleft: 'List of ALL users in the foeface system. Click on a user to add or remove from the bulk password change list.',
    titleright: 'Password Change List',
    messageright: 'List of users who will be included in the change password process.  After changing you will be able to download new passwords as a PDF.'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/admin/passwords.localisations.js